<template>
	<v-sheet color="transparent" class="mb-12" @click="warn">
		<question
			v-for="id in ids"
			:key="id"
			:id="id"
			:staffSurvey="staffSurvey"
			v-model="value[id]"
			:poll="poll"
			:disabled="disabled"
		></question>
	</v-sheet>
</template>

<style lang="less"></style>

<script type="text/javascript">
import Question from "@c/survey/render/Question";

export default {
	name: "Questions",
	props: {
		ids: { type: Array },
		value: { type: Object },
		disabled: { type: Boolean },
		staffSurvey: { type: Boolean },
		poll: { type: Boolean },
	},
	data: () => {
		return {};
	},
	components: {
		Question,
	},
	computed: {
		questions() {
			return this.$store.state.questions.data;
		},
		questionTemplates() {
			return this.$store.state.questionTemplates.data;
		},
	},
	methods: {
		warn() {
			if (this.disabled) {
				this.$emit("error", "delegated");
			}
		},
	},
};
//
</script>
"
